const currencyPrefix = {
  BRL: 'R$ ',
  PEN: 'S/ ',
};

export default currencyPrefix;
